import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { queryString } from '@qadra/frontend-common';
import { FlexWrapper, SPACINGS } from '@qadra/frontend-common-ts';
import { Button, Card, Alert, Form, FormInput } from '@qadra/frontend-common/atoms';
import { Row, Col } from '@qadra/frontend-common/grid';
import { connect, push } from '@qadra/frontend-common/redux';
import { validations } from '@qadra/frontend-common/validations';
import { Heading } from '@qadra/frontend-common/typography';
import { monitoring } from '@qadra/frontend-common/tracking';
import { ACTIVATE } from '../redux/actions';
import { withTranslate } from '../utils/translations';
import { paths } from '../utils';
import { CardWrapper } from './styles';

class Activate extends Component {
  constructor(props) {
    super(props);
    const { code } = queryString.parse(this.props.location.search);
    this.state = {
      code,
    };
  }

  componentDidMount() {
    if (!this.state.code) {
      monitoring.captureMessage('No code in Activate page');
      this.gotoLogin();
    }
  }

  doCreatePass = ({ Password, ConfirmPassword }) => {
    this.props.onSendPass({
      Password,
      ConfirmPassword,
      Code: this.state.code,
    });
  };

  gotoLogin = () => this.props.pushUrl(paths.login);

  validate = ({ Password, ConfirmPassword }) =>
    Password !== ConfirmPassword
      ? { ConfirmPassword: this.props.t('sso.activate.passNotMatch') }
      : {};

  render() {
    const { t, error } = this.props;
    return (
      <>
        {error && (
          <Alert style={{ marginBottom: 50 }} type="danger">
            {error}
          </Alert>
        )}
          <Card style={{ width: '100%', maxWidth: "500px", marginBottom: 0 }}>
            <Row>
              <Col xs={12}>
                <FlexWrapper style={{width: '100%', marginBottom: SPACINGS[12]}} justify='center'>
                  <Heading type={2}>{t('sso.activate.createPass')}</Heading>
                </FlexWrapper>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form
                  innerRef={(r) => (this.form = r)}
                  validate={this.validate}
                  onSubmit={this.doCreatePass}
                >
                  <FormInput
                    label="Password"
                    name="Password"
                    type="password"
                    small={t('sso.activate.createPassHint')}
                    initialValue=""
                    required
                    pattern={validations.password.reg}
                    patternErr={validations.password.error}
                  />
                  <FormInput
                    label={t('sso.activate.confirmPass')}
                    name="ConfirmPassword"
                    type="password"
                    initialValue=""
                    required
                  />
                </Form>
              </Col>
            </Row>
            <Row>
              <FlexWrapper style={{width: '100%', marginTop: SPACINGS[20]}} justify='center'>
                <Button
                  label={t('sso.activate.createPassBtn')}
                  onClick={() => this.form.submitForm()}
                />
              </FlexWrapper>
            </Row>
          </Card>
      </>
    );
  }
}

Activate.propTypes = {
  location: PropTypes.object,
  onSendPass: PropTypes.func,
  pushUrl: PropTypes.func,
  error: PropTypes.string,
};

export default withTranslate(
  connect(
    (state) => ({
      location: state.router.location,
      error: state.activate.error,
    }),
    (dispatch) => ({
      pushUrl: (url) => dispatch(push(url)),
      onSendPass: (payload) =>
        dispatch({
          type: ACTIVATE._REQUEST,
          payload,
        }),
    })
  )(Activate)
);
